import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { CustomDialog, StyledDataGrid } from '../../../components/StyledComponents'
import { DialogActions, DialogContent, DialogTitle, Box, Checkbox } from '@mui/material'
import { ControlpanelPrimaryButton, ControlpanelSecondaryButton, GrayIconButton } from '../../../components/StyledButton'
import CloseIcon from '@mui/icons-material/Close';
import AddBoxIcon from '@mui/icons-material/AddBox';
import { useTranslation } from 'react-i18next';
import CustomCropImage from '../CustomCropImage/CustomCropImage';
import SearchIcon from '@mui/icons-material/Search';
import CustomInput from '../../../components/CustomInput';
import my_company_logo from "../../../assets/images/logo/my-company-logo.png"
import SaveIcon from '@mui/icons-material/Save';
import { useLoading } from '../../../context/LoadingContext';
import { toast } from 'react-toastify';
import { updateUserToGroup } from '../../../axios/Group/GroupUrlApi';
import DefaultTooltip from '../../../components/DefaultTooltip';
import QuestionIcon16pxSvg from '../../../assets/images/icons/QuestionIcon16pxSvg';
import ArrowRepeatIcon16pxSvg from '../../../assets/images/icons/ArrowRepeatIcon16pxSvg';
import CustomPagination from '../CustomPagination';
import NoRowOverlay from '../../../assets/images/icons/NoRowOverlay';
import Cookies from "js-cookie";
import { getUserList } from '../../../axios/User/UserApi';
import { useAuth } from '../../../context/AuthContext';
import { generateTranslateMuiTable } from '../../../utils/Function/commonFunction';
import CustomColumnsPanel from '../../../components/CustomColumnsPanel';
import CustomGridToolbarQuickFilter from '../CustomGridToolbarQuickFilter';
import CustomGridToolbarQuickFilterNew from '../CustomGridToolbarQuickFilterNew';
import CustomGridToolbarQuickFilterNew2 from '../CustomGridToolbarQuickFilterNew2';
import ServerSearchInput from '../../../components/ServerSearchInput';

const AddUserToGroupDialog = ({ isOpen, onClose, handleRefreshTable, info, userGroup, refreshInfo, handleRefreshInfo }) => {
  const { t, i18n } = useTranslation()
  const { profile } = useAuth();
  const currentLang = i18n.language;
  const [selectedUserIds, setSelectedUserIds] = useState([]);
  const [show, hide] = useLoading();
  const [userData, setUserData] = useState([]);
  const [gridLoading, setGridLoading] = useState(false);
  const [rowCount, setRowCount] = useState(0)
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(50);
  const handleCloseDialog = () => {
    onClose()
  }
  const [rowData, setRowData] = useState([]);
  const [adminStatusMap, setAdminStatusMap] = useState({});
  const tableTranslated = useMemo(() => generateTranslateMuiTable(t), [t]);
  const [searchText, setSearchText] = useState("");
  const [debouncedSearchText, setDebouncedSearchText] = useState("");
  const handleSearchChange = (value) => {
    setSearchText(value);
  };
  const encodedSearchText = useMemo(() => {
    return searchText;
  }, [searchText]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchText(encodedSearchText);
      setPage(0);
    }, 700);

    return () => clearTimeout(handler);
  }, [encodedSearchText]);

  useEffect(() => {
    const fetchData = async () => {
      setGridLoading(true);
      try {
        const payload = {
          statusId: 1,
          page: page + 1,
          pageSize: pageSize,
          status: true,
          langId: localStorage.getItem("i18nextLngId"),
          searchText: debouncedSearchText || null,
        }
        const response = await getUserList(payload);
        // const { data, headers } = await getUserList(page + 1, pageSize);
        setRowCount(response.data.pagination.totalElements)
        // const employees = data.listEmployeeData;
        const employees = response.data.data.map(e => ({
          ...e,
          isAdmin: adminStatusMap[e.userId] ?? false,
        }));
        // if (employees.length > 0) {
        setUserData(employees);
        // }
      } catch (error) {
        if (error.response) {
          if (error.response.status !== 401) {
            toast.error(t(error?.response.data));
          }
        } else {
          toast.error(t('common.network-timeout'));
        }
      } finally {
        setGridLoading(false);
      }
    };

    fetchData();
  }, [page, pageSize, debouncedSearchText]);

  const columnData = [
    {
      field: 'isSelected',
      headerName: t('common.content-077'),
      minWidth: 60,
      flex: 1,
      renderHeader: () => (
        <Checkbox
          checked={allChecked}
          indeterminate={!allChecked && someChecked}
          onChange={(event) => handleSelectAllCheckbox(event.target.checked)}
        />
      ),
      renderCell: (params) => (
        <Checkbox
          checked={params.row.isAdmin}
          onChange={(event) => {
            handleCheckboxChange(params.row.userId, "isAdmin", event.target.checked);
          }}
        />
      ),
    },
    { field: 'employeeCode', headerName: t('common.employee-code'), minWidth: 70, flex: 1 },
    {
      field: "personalID",
      headerName: t("common.content-131"),
      minWidth: 150,
      flex: 1,
    },
    {
      field: 'fullName', headerName: t('common.full-name'), minWidth: 250, flex: 1
    },
    { field: 'email', headerName: 'Email', minWidth: 200, flex: 1 },
    {
      field: "administratorRights",
      headerName: t("common.admin"),
      minWidth: 180,
      hideable: true,
      rowSpanValueGetter: (value, row) =>
        row ? `${row.id}-${row.administratorRights}` : value,
      renderCell: (params) => {
        const { administratorRights: rights, owner } = params.row || {};

        // mapping key dịch
        const roleLabelMap = {
          EMPLOYEE: t("roles2.Employee"),
          AUDITOR: t("roles2.Auditor"),
          ADMIN: t("roles2.Admin"),
          SUBCRIPTION: t("roles2.SubscriptionAdmin"),
        };

        const displayValue =
          roleLabelMap[rights] ||
          (rights !== null && rights !== undefined && rights !== ""
            ? rights
            : "-");

        return (
          <p className="flex items-center">
            <span className="mr-1">{displayValue}</span>
            {owner && (
              <span className="text-red-500">
                ({t("common.content-125")})
              </span>
            )}
          </p>
        );
      },
    },
    {
      field: 'userTypeId', headerName: t("common.user-type"), minWidth: 200, flex: 1, rowSpanValueGetter: (value, row) =>
        row ? `${row.id}-${row.userTypeId}` : value,
      valueFormatter: (value) => {
        if (value === null || value === undefined) return "-";
        if (value === 1) return t("common.full-time");
        if (value === 2) return t("common.part-time");
      },
    },

  ];

  const handleCheckboxChange = (userId, columnName, isChecked) => {
    const updatedRows = rowData.map((row) => {
      if (row.userId === userId) {
        return { ...row, [columnName]: isChecked };
      }
      return row;
    });

    const updatedSelectedIds = isChecked
      ? [...selectedUserIds, userId]
      : selectedUserIds.filter(id => id !== userId);

    setRowData(updatedRows);
    setSelectedUserIds(updatedSelectedIds);
  };


  const handleSelectAllCheckbox = (isChecked) => {
    const updatedRows = rowData.map(row => ({
      ...row,
      isAdmin: isChecked,
    }));

    const updatedSelectedIds = isChecked
      ? Array.from(new Set([...selectedUserIds, ...updatedRows.map(row => row.userId)])) // tránh thêm trùng
      : selectedUserIds.filter(id => !updatedRows.map(row => row.userId).includes(id)); // bỏ userId trên trang hiện tại

    setRowData(updatedRows);
    setSelectedUserIds(updatedSelectedIds); // 👈 lưu lại trạng thái chọn
  };

  const handleSubmit = async (e) => {
    const payload = {
      group: info?.id,
      listUser: selectedUserIds.join(","),
      langId: localStorage.getItem("i18nextLngId")
    }
    try {
      e.preventDefault();
      show();
      const response = await updateUserToGroup(payload);
      toast.success(t('common.update-user-to-group-successfully'));

      handleRefreshInfo();
      handleCloseDialog();
    } catch (error) {
      if (error.response) {
        if (error.response.status !== 401) {
          toast.error(t(error?.response.data));
        }
      } else {
        toast.error(t('common.network-timeout'));
      }

    } finally {
      hide();
    }
  };

  useEffect(() => {
    if (userData.length === 0) return;

    const updatedData = userData.map(user => ({
      ...user,
      isAdmin: selectedUserIds.includes(Number(user.userId)), // 👈 tái áp dụng trạng thái đã chọn
    }));

    setRowData(updatedData);
  }, [userData, selectedUserIds]);

  useEffect(() => {
    if (isOpen && Array.isArray(userGroup)) {
      const selectedIds = userGroup.map(u => Number(u.id));
      setSelectedUserIds(selectedIds); // 👈 chỉ cần set 1 lần
    }
  }, [isOpen]);

  const allChecked = useMemo(() => {
    return rowData.length > 0 && rowData.every(row => row.isAdmin);
  }, [rowData]);

  const someChecked = useMemo(() => {
    return rowData.some(row => row.isAdmin);
  }, [rowData]);

  const [columnVisibilityModel, setColumnVisibilityModel] = useState({
    employeeCode: true,
    name: true,
    firstName: true,
    lastName: true,
    telephone: false,
    designation: false,
    createdTime: false,
    modifiedTime: false,
    administratorRights: true,
    active: true,
  });
  const emailUser = profile?.email;
  const handleColumnVisibilityChange = (newModel) => {
    setColumnVisibilityModel(newModel);
    Cookies.set(`AddUserToGroupDialog_${emailUser}`, JSON.stringify(newModel), {
      expires: 90,
      path: "/",
    });
  };

  useEffect(() => {
    const saved = Cookies.get(`AddUserToGroupDialog_${emailUser}`);
    if (saved) {
      setColumnVisibilityModel(JSON.parse(saved));
    }
  }, []);

  const handleQuickFilterChange = (searchText) => {
    const lowerSearch = searchText.toLowerCase();
    const filtered = rowData.filter((row) =>
      Object.values(row).some((val) =>
        String(val).toLowerCase().includes(lowerSearch)
      )
    );
    setUserData(filtered);
  };

  const templateToolbar = useCallback(
    () => (
      <div className="flex gap-2 justify-end mb-2">
        {/* <CustomGridToolbarQuickFilterNew2
            onSearchChange={handleQuickFilterChange}
          /> */}
        <ServerSearchInput fullWidth onChange={handleSearchChange} />
      </div>
    ),
    [t]
  );


  return (
    <CustomDialog
      maxWidth={"xl"}
      open={isOpen}
      onClose={handleCloseDialog}
      keepMounted
      transitionDuration={window.__tourIsOpen ? 0 : undefined}
      data-tour="user-group-button-group-user-dialog"
    >
      <DialogTitle>
        <div className='flex justify-between'>
          <div className='flex items-center gap-4'>
            <p className='text-xl font-semibold '>{t('common.select-users-for-user-group')}</p>
            <DefaultTooltip
              title={t('tool-tip.add-edit-user-group')}
              readMore={false}
              content={
                <div className='flex flex-col gap-3'>
                  <p>{t('tool-tip.this-view-allows-to-add-a-new-user-group')}.</p>
                </div>
              }>
              <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
            </DefaultTooltip>
          </div>
          <GrayIconButton onClick={handleCloseDialog}>
            <CloseIcon />
          </GrayIconButton>
        </div>
      </DialogTitle>
      <DialogContent style={{ paddingBottom: 'unset' }}>

        <div className='h-auto mt-2'>
          <StyledDataGrid
            sx={{
              height: '600px',
              width: '100%',
            }}
            rows={rowData}
            rowCount={rowCount}
            columns={columnData}
            getRowId={(r) => r.userId}
            loading={gridLoading}
            disableRowSelectionOnClick

            slots={{
              toolbar: templateToolbar,
              pagination: CustomPagination,
              noRowsOverlay: NoRowOverlay,
              columnsPanel: CustomColumnsPanel,
            }}
            slotProps={{
              pagination: {
                page,
                count: rowCount,
                rowsPerPage: pageSize,
                onPageChange: setPage,
                onRowsPerPageChange: setPageSize,
              },
            }}
            localeText={tableTranslated}
            columnVisibilityModel={columnVisibilityModel}
            onColumnVisibilityModelChange={handleColumnVisibilityChange}

          />

        </div>
      </DialogContent>
      <DialogActions>
        <div className='flex gap-2 px-4 py-4'>
          <ControlpanelSecondaryButton onClick={handleCloseDialog}>
            <p>{t('button.close')}</p>
          </ControlpanelSecondaryButton>
          <ControlpanelPrimaryButton onClick={handleSubmit}>
            <p>{t('button.confirm')}</p>
          </ControlpanelPrimaryButton>
        </div>
      </DialogActions>
    </CustomDialog>
  )
}

export default AddUserToGroupDialog